import styled from 'styled-components';

const LoaderBlock = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 16px;
`;

export default LoaderBlock;
